import classNames from "classnames";
import { Link, LinkProps } from "react-router-dom";
import { getNotFoundImg } from "@outplayed/riot-assets";

export function LeaderboardLoading({ className }: { className?: string }) {
  return (
    <div
      className={classNames(
        `flex justify-center items-center p-[12px]
        min-h-screen w-full rounded-[3px] bg-purple-400`,
        className,
      )}
    >
      <div className="spinthatshit-loader self-start mt-[64px]">
        <div className="spinner"></div>
      </div>
    </div>
  );
}
